import 'css-chunk:src/app/components/Editor/components/ImageBlock.module.scss';export default {
  "ImageBlock": "_ImageBlock_zu22i_1",
  "align-left": "_align-left_zu22i_6",
  "align-center": "_align-center_zu22i_9",
  "align-right": "_align-right_zu22i_12",
  "resizing": "_resizing_zu22i_15",
  "image": "_image_zu22i_15",
  "resizeHandle": "_resizeHandle_zu22i_18",
  "imageContainer": "_imageContainer_zu22i_23",
  "controls": "_controls_zu22i_28",
  "resizeOverlay": "_resizeOverlay_zu22i_52",
  "resizeInfo": "_resizeInfo_zu22i_65",
  "controlButton": "_controlButton_zu22i_99",
  "altEditContainer": "_altEditContainer_zu22i_110",
  "altInput": "_altInput_zu22i_116",
  "altSaveButton": "_altSaveButton_zu22i_120",
  "bottomRight": "_bottomRight_zu22i_146",
  "menuItem": "_menuItem_zu22i_179",
  "activeAlignment": "_activeAlignment_zu22i_185"
};